import * as type from '../types/single-list'

export const retrieveSingleListDetails = payload => {
    return{
        type: type.REQUEST_SINGLE_LIST_DETAILS,
        payload: payload
    }
}

export const resetSingleListDetails = () => {
    return{
        type: type.RESET_SINGLE_LIST_DETAILS,
    }
}

export const retrieveSingleListResponses = payload => {
    return{
        type: type.REQUEST_SINGLE_LIST_RESPONSES,
        payload: payload
    }
}

export const requestActiveCompanyDetails = payload => {
    return{
        type: type.REQUEST_SET_ACTIVE_COMPANY_DETAILS,
        details: payload
    }
}

export const resetActiveCompanyDetails = () => {
    return{
        type: type.RESET_SET_ACTIVE_COMPANY_DETAILS
    }
}

export const requestActiveCompanyNotes = payload => {
    return{
        type: type.REQUEST_SET_ACTIVE_COMPANY_NOTES,
        details: payload
    }
}

export const resetActiveCompanyNotes = () => {
    return{
        type: type.RESET_SET_ACTIVE_COMPANY_NOTES
    }
}

export const retrieveActiveCompanyStatus = payload => {
    return{
        type: type.REQUEST_LIST_COMPANY_STATUS,
        details: payload
    }
}

export const resetActiveCompanyStatus = () => {
    return{
        type: type.RESET_LIST_COMPANY_STATUS
    }
}

export const requestDeleteListCompanyNote = payload => {
    return{
        type: type.REQUEST_REMOVE_LIST_COMPANY_NOTE,
        details: payload
    }
}

export const resetDeleteListCompanyNote = () => {
    return{
        type: type.RESET_REMOVE_LIST_COMPANY_NOTE
    }
}

export const requestAddListCompanyNote = payload => {
    return{
        type: type.REQUEST_ADD_LIST_COMPANY_NOTE,
        details: payload
    }
}

export const resetAddListCompanyNote = () => {
    return{
        type: type.RESET_ADD_LIST_COMPANY_NOTE
    }
}

export const requestAddNewClient = payload => {
    
    return{
        type: type.REQUEST_CREATE_NEW_CLIENT,
        details: payload
    }
}

export const resetAddNewClient = () => {
    return{
        type: type.RESET_CREATE_NEW_CLIENT
    }
}

export const requestAddNewOpportunity = payload => {
    return{
        type: type.REQUEST_CREATE_NEW_OPPORTUNITY,
        details: payload
    }
}

export const resetAddNewOpportunity = () => {
    return{
        type: type.RESET_CREATE_NEW_OPPORTUNITY
    }
}

export const requestAddNewContact = payload => {
    return{
        type: type.REQUEST_CREATE_NEW_CONTACT,
        details: payload
    }
}

export const resetAddNewContact = () => {
    return{
        type: type.RESET_CREATE_NEW_CONTACT
    }
}

export const requestRemoveExistingClient = payload => {
    return{
        type: type.REQUEST_REMOVE_EXISTING_CLIENT,
        details: payload
    }
}

export const resetRemoveExistingClient = () => {
    return{
        type: type.RESET_REMOVE_EXISTING_CLIENT
    }
}

export const requestAddListCompanyResponse = payload => {
    return{
        type: type.REQUEST_ADD_LIST_COMPANY_RESPONSE,
        details: payload
    }
}

export const resetAddListCompanyResponse = () => {
    return{
        type: type.RESET_ADD_LIST_COMPANY_RESPONSE
    }
}

export const retrieveCompanyDeletions = payload => {
    return{
        type: type.REQUEST_COMPANY_DELETIONS,
        details: payload
    }
}

export const resetCompanyDeletions = () => {
    return{
        type: type.RESET_REMOVE_LIST_COMPANY_NOTE
    }
}

export const requestRemoveCompanyListing = payload => {
    return{
        type: type.REQUEST_REMOVE_COMPANY_LISTING,
        details: payload
    }
}

export const resetRemoveCompanyListing = () => {
    return{
        type: type.RESET_REMOVE_COMPANY_LISTING
    }
}

export const setCompanyList = payload => {
    return{
        type: type.SET_UPDATED_COMPANY_LIST,
        details: payload
    }
}

export const resetCompanyList = payload => {
    return{
        type: type.RESET_UPDATED_COMPANY_LIST
    }
}

export const changeSingleListModal = payload => {
    return{
        type: type.CHANGE_SINGLE_LIST_MODALS,
        modal: payload
    }
}

export const setDisplayIndex = payload => {
    return{
        type: type.SET_SINGLE_LIST_DISPLAY_INDEX,
        index: payload
    }
}

export const requestFetchContactLists = payload => {
    return{
        type: type.REQUEST_FETCH_CONTACT_LISTS,
        details: payload
    }
}

export const resetFetchContactLists = payload => {
    return{
        type: type.RESET_FETCH_CONTACT_LISTS
    }
}